import { Link } from 'react-router-dom'
import SiteHeader from '../components/SiteHeader'
import SiteBackdrop from '../components/SiteBackdrop'

export default function NotFoundPage() {
  return (
    <div className="not-found-shell">
      <SiteBackdrop />
      <SiteHeader />
      <main className="not-found">
        <p className="eyebrow">ROUTE NOT FOUND</p>
        <p className="error-code" aria-hidden="true">404</p>
        <h1>This road is not in the active Drive Pack.</h1>
        <p>Return to Road Stack or open the cockpit demo.</p>
        <div className="not-found-actions">
          <Link className="button button--primary" to="/">Return home</Link>
          <Link className="button button--secondary" to="/demo">Watch the demo</Link>
        </div>
      </main>
    </div>
  )
}
